

import { CompanyVehicle } from '@/types';
import {
  createGenericColumns,
  createDateCell,
  createBooleanBadgeCell,
  GenericColumnConfig
} from '@/shared/components/GenericTableColumns';

/**
 * 社用車テーブルのカラム設定
 */
const companyVehiclesColumnConfigs: GenericColumnConfig<CompanyVehicle>[] = [
  {
    accessorKey: 'name',
    header: '車両名',
    sortable: true,
    size: 200,
    cell: (value) => <div className="font-medium">{value}</div>,
  },
  {
    accessorKey: 'daily_cost',
    header: '日額料金',
    sortable: true,
    size: 120,
    cell: (value) => <div className="text-right">¥{Number(value).toLocaleString()}</div>,
  },
  {
    accessorKey: 'is_active',
    header: '有効状態',
    sortable: true,
    size: 100,
    cell: createBooleanBadgeCell('有効', '無効', 'default', 'destructive'),
  },
  {
    accessorKey: 'created_at',
    header: '登録日時',
    sortable: true,
    size: 150,
    cell: createDateCell,
  },
];

/**
 * 社用車マスタデータのカラム定義 (Generic版)
 * 元のcolumns.tsxを置き換える改良版
 */
export const columns = createGenericColumns<CompanyVehicle>(
  companyVehiclesColumnConfigs,
  {
    showSelect: true,
    actionMenu: {
      showCopyId: true,
      items: [
        {
          label: '編集',
          onClick: (vehicle) => {
            // 編集処理は親コンポーネントで実装される
            console.log('Edit vehicle:', vehicle.id);
          },
        },
        {
          label: '削除',
          onClick: (vehicle) => {
            // 削除処理は親コンポーネントで実装される
            console.log('Delete vehicle:', vehicle.id);
          },
          variant: 'destructive',
          show: (vehicle) => !vehicle.is_active, // 無効な車両のみ削除可能
        },
      ],
    },
  }
);

/**
 * カスタムアクションメニュー付きカラムを生成する関数
 */
export function createCompanyVehiclesColumns(actions?: {
  onEdit?: (vehicle: CompanyVehicle) => void;
  onDelete?: (vehicle: CompanyVehicle) => void;
}) {
  return createGenericColumns<CompanyVehicle>(
    companyVehiclesColumnConfigs,
    {
      showSelect: true,
      actionMenu: {
        showCopyId: true,
        items: [
          ...(actions?.onEdit ? [{
            label: '編集',
            onClick: actions.onEdit,
          }] : []),
          ...(actions?.onDelete ? [{
            label: '削除',
            onClick: actions.onDelete,
            variant: 'destructive' as const,
            show: (vehicle: CompanyVehicle) => !vehicle.is_active,
          }] : []),
        ],
      },
    }
  );
}